<template>
  <div id="background">
    <p id="dashboardItemTitle">History</p>
    <div style="margin-top: 30px">

      <template v-if="tableRows.length < 1" >
        <div class="empty-indicator">
            <span class="icon has-text-grey-lighter is-normal">
                <i class="mdi mdi-information-outline mdi-24px"></i>
            </span>
          <span class="ml-2 has-text-grey-lighter">No records to display</span>
        </div>
      </template>
      <b-table v-else :data="tableRows" :columns="columns"></b-table>
    </div>

  </div>
</template>


<script>

export default {
  data(){
    return {
      tableRows: [],
      columns: [

        {
          field: 'created_by',
          label: 'Created By',
          width: '200',
          centered:true,

        },
        {
          field: 'title',
          label: 'Title',
          centered:true,
        },
        {
          field: 'status',
          label: 'Status',
          centered:true,
        },
        {
          field: 'recipient',
          label: 'Recipient',
          centered:true,
        }
      ]
    }
  }
}
</script>
<style scoped>
  #dashboardItemTitle{
    color: #A5A6B3;
    font-weight: 600;
    font-size: 30px;
    text-align: left
  }

  #background{

  }
</style>